// Only run if user prefers reduced motion
if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
  const freezeGif = (img) => {
    const cover = () => {
      const { width, height } = img;

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);

      Object.assign(canvas.style, {
        position: 'absolute',
        inset: '0',
        margin: 'auto',
      });

      canvas.setAttribute('aria-hidden', 'true');
      canvas.setAttribute('role', 'presentation');

      const parent = img.parentNode;
      parent.style.position ||= 'relative';

      parent.insertBefore(canvas, img);
      img.style.opacity = '0.01';
    };

    img.complete ? cover() : img.addEventListener('load', cover, { once: true });
  };

  document.querySelectorAll('img[src*=".gif"]').forEach(freezeGif);
}
